import React, { useRef } from 'react'
import { MapContainer,Marker,Popup,TileLayer } from 'react-leaflet'
import l from 'leaflet'
import 'leaflet/dist/leaflet.css'
const OkayMap = () => {
    const ref=useRef()
    const maker=new l.icon({
        iconUrl:'https://unpkg.com/leaflet@1.6.0/dist/images/marker-icon-2x.png',
        iconSize:[25,35],
        popupAnchor:[-3,7],
       iconAnchor:[14,-7]
    })
  return (
    <div>
       <MapContainer center={[5.920386,-0.4143856]} zoom={13} ref={ref}>
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        <Marker position={[6.6755675,-1.5585591]} icon={maker}>
            <Popup>
                <h3>Okay GuestHoues</h3>
            </Popup>
        </Marker>
      </MapContainer>
    </div>
  )
}

export default OkayMap